import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { QualityGateFilter } from "../../../../../api/models/quality-gate-filter";
import { QualityGateService } from "../../../../../api/services/quality-gate.service";
import { TransactionTagsEntry } from "../../../../../api/models/transaction-tags-entry";
import { QualityGateSubmission } from "../../../../../api/models/quality-gate-submission";
import { QualityGateMultiSubmission } from "src/api/models";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-type-flags-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class TypeFlagsUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  unprocessedTransactions: TransactionTagsEntry[] = [];
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedTransactions();
  }

  onExcludeClick(share: TransactionTagsEntry) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Transaction_Tags",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: share.entryId ?? 0,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getUnprocessedTransactions();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  onSearch() {
     const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedTransactions();
  }
  preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  getUnprocessedTransactions() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "Transaction_Tags",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedTransactions = value.transactionTagsEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedTransactions?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  onGroupExclusionClick() {
    const entryIds = this.selectedTag
      .filter((share) => share.entryId !== undefined)
      .map((share) => share.entryId);
    const submission: QualityGateMultiSubmission = {
      entryIds: entryIds,
      indeterminable: true,
      qualityGateType: "Transaction_Tags",
    };

    this._qualityGateService.multiSubmission(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.selectedTag = [];
        this.getUnprocessedTransactions();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
}
